import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


function FilterInputSearch({ filter, onSubmit, onUpdate }) {
    const [searchValue, setSearchValue] = useState(filter.value);
    const dictionary = useSelector((state) => state.localization.dictionary);

  useEffect(() => {
    setSearchValue(filter.value);
  }, [filter.value]);

  function onSubmitClick() {
    const changedFilter = {
      ...filter,
      value: searchValue,
    };
    onSubmit(changedFilter);
  }

  function onSearchKeyUp(evt) {
    evt.stopPropagation();
    if (evt.keyCode === 13) {
      onSubmitClick();
    }
  }

  return (
    <div className="app-search-input">
      <label className="offscreen" htmlFor="search">
        Search
      </label>
      <div className="app-search-input--flex">
        <input
          value={searchValue}
          type="text"
          onKeyDown={(evt) => {
            onSearchKeyUp(evt);
          }}
          onChange={(evt) => {
            setSearchValue(evt.target.value);
            onUpdate({
              ...filter,
              value: evt.target.value
            })
          }}
          id="search"
        />
        <button type="button" onClick={onSubmitClick}>
             {dictionary["CNHS.Filter.GeneralSubmit"]}
        </button>
      </div>
    </div>
  );
}

export default FilterInputSearch;
